import { TripFolderPdfInput } from '../../lib/types/models/trip-folder/trip-folder'
import { downloadDocuments } from '../../lib/utils/files/download-documents'
import { API, constructApiUrl } from '../apis.config'

export async function generateTripFolderPdf(id: number, data: TripFolderPdfInput) {
  return downloadDocuments<TripFolderPdfInput>({
    data,
    endpoint: constructApiUrl(API.tripFolder.generatePdf.url, { id })
  })
}
